"use client";

/**
 * AI 비서 답변 피드백 (👍/👎) — 마이그 057, 2026-05-12.
 *
 * - 같은 버튼 다시 클릭 = 평가 취소 (clear)
 * - 다른 버튼 클릭 = 평가 변경
 * - 본인 답변만 평가 가능 (backend 검증)
 */
import { useState } from "react";
import axios from "axios";
import { useAuthStore } from "@/store/auth";

interface Props {
  messageId: number;
  initialRating?: "up" | "down" | null;
}

export function FeedbackButtons({ messageId, initialRating = null }: Props) {
  const { token } = useAuthStore();
  const [rating, setRating] = useState<"up" | "down" | null>(initialRating);
  const [busy, setBusy] = useState(false);

  const submit = async (next: "up" | "down") => {
    if (!token || busy) return;
    const target = rating === next ? "clear" : next;
    setBusy(true);
    try {
      await axios.post(
        `/api/chat/messages/${messageId}/feedback`,
        { rating: target },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setRating(target === "clear" ? null : next);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-1 mt-1.5 ml-1">
      <button
        type="button"
        onClick={() => submit("up")}
        disabled={busy}
        aria-label="도움됐어요"
        className={`text-xs px-1.5 py-0.5 rounded transition-colors disabled:opacity-40 ${
          rating === "up" ? "text-emerald-500" : "text-text-sub hover:text-emerald-500"
        }`}
      >
        👍
      </button>
      <button
        type="button"
        onClick={() => submit("down")}
        disabled={busy}
        aria-label="별로예요"
        className={`text-xs px-1.5 py-0.5 rounded transition-colors disabled:opacity-40 ${
          rating === "down" ? "text-red-500" : "text-text-sub hover:text-red-500"
        }`}
      >
        👎
      </button>
    </div>
  );
}
